// root actions
import { menu } from '@/api.js'
const getMenuTree = (data) => {
  let cloneData = JSON.parse(JSON.stringify(data.data))
  cloneData.filter(father => {
    let branchArr = cloneData.filter(child => father.resourceId === child.parentResourceId).sort((a, b) => a.ordnum - b.ordnum) // 返回每一项的子级数组
    branchArr.length > 0 ? father.children = branchArr : father.children = '' // 如果存在子级，则给父级添加一个children属性，并赋值
  })
  return cloneData.filter(item => item.parentResourceId === 0).sort((a, b) => a.ordnum - b.ordnum)
}
export default {
  getMenuList({ commit }) {
    // 取菜单列表
    // const rst = []
    return menu.getMenu().then(({ data }) => {
      if (data.status === 0) {
        // 把菜单变成有序的含层级的列表
        commit('setOriginMenuList', data.data)
        commit('setMenuList', getMenuTree(data))
      }
    })
  }
}
